/**
 * 二次授权提示用户
 * */
import React, { Fragment, PureComponent } from 'react';
import { Modal } from 'antd';
import './SecondaryAuthTip.scss';
import SecondaryAuthorization from './SecondaryAuthorization';
import IframeModal from '../../iframModal/IframModal';
import {
  _change_sy_secondary_auth_error,
  _change_sy_user_login_info,
  _h5_link_to,
  _show_login_modal,
} from '../../../store/Action';
import qs from 'qs';
import Util from '../../../script/util';

export default class SecondaryAuthTip extends PureComponent {
  state = {
    visible: false,
    isWx: false, // 是否是微信
  };
  hideModal = (type = 'close') => {
    if (type === 'cancel') {
      this.clearUserData();
    }
    this.setState({ visible: false });
  };
  clearUserData = () => {
    _change_sy_secondary_auth_error({ wx: false, qq: false, phone: false });
    _change_sy_user_login_info(null); //  清除所有登录信息
    _show_login_modal(); // 弹出登录页面
  };
  // 提示 微信 二次授权登录
  WXSecondaryModal = () => {
    this.setState({ visible: true, isWx: true });
  };
  // 提示 QQ 二次授权登录
  QQSecondaryModal = () => {
    this.setState({ visible: true, isWx: false });
  };

  isWeixinLogin = () => {
    return !!this.state.isWx;
  };

  // 登录遇到问题
  handleQuestions = () => {
    const { isWx } = this.state;
    // 打开对应的 H5 页面
    _h5_link_to(
      `/account-question-login/index.html?register=${isWx ? 1 : 2}`
    ).then((res) => {
      this.iframeElement.showModal(res.url + '?' + qs.stringify(res.params));
    });
  };

  // 确认提交
  handleConfirm = () => {
    if (this.state.isWx) {
      this.secondaryAuthorizationEle.WXSecondaryModal();
    } else {
      this.secondaryAuthorizationEle.QQSecondaryModal();
    }
    this.hideModal();
  };

  render() {
    const { visible } = this.state;
    const { rootConfig, syUserLoginInfo } = this.props.base;

    return (
      <Fragment>
        <Modal
          open={visible}
          title="身份验证"
          wrapClassName="daidai-modal-style has-top-border"
          centered={true}
          footer={null}
          keyboard={false}
          maskClosable={false}
          width="600px"
          onCancel={() => this.hideModal('cancel')}
        >
          {visible ? (
            <div className="second-auth-tip-plan">
              <div className="tip-msg">
                <div
                  className={`icon-type ${this.isWeixinLogin() ? 'wx' : 'qq'}`}
                />
                <p>
                  请使用当前登录的昵称为“
                  <span
                    className={`nick ${this.isWeixinLogin() ? 'wx' : 'qq'}`}
                  >
                    {syUserLoginInfo.nickName}
                  </span>
                  ”的{this.isWeixinLogin() ? '微信' : 'QQ'}号授权验证身份
                </p>
              </div>
              <ul className="tip-desc-ul">
                <li className="tip-desc-li">
                  为了处理您的账号申诉、解除冻结等申请和增加账号安全性，根据相关法律法规的规定和有权机关的要求，我们需要收集您微信/QQ授权登录的账号昵称、头像信息。上述信息为您的个人敏感信息，若无法提供上诉信息，可能导致您无法完成验证。该等信息未经您的明示授权，不会作其他目的。
                </li>
                <li className="tip-desc-li">
                  本流程用户信息收集开发者名称：武汉苇渡文化传媒有限公司。
                </li>
              </ul>
              <div className="second-auth-msg">
                <div className="second-auth-line">
                  <p className="line-label">
                    当前登录的{this.isWeixinLogin() ? '微信' : 'QQ'}账号
                  </p>
                  <p className="line-value">
                    <span className="auth-avatar">
                      <img
                        src={Util.transImgUrlToGame(syUserLoginInfo.avatar)}
                        alt="头像"
                      />
                    </span>
                    <span className="auth-nick">
                      {syUserLoginInfo.nickName}
                    </span>
                  </p>
                </div>
                <div className="second-auth-line">
                  <p className="line-label">手机绑定</p>
                  <p className="line-value">
                    <span className="auth-phone">
                      {rootConfig.lang !== 'zh_CN' && syUserLoginInfo.areaCode
                        ? syUserLoginInfo.areaCode
                        : ''}{' '}
                      {Util.getPrivatePhone(
                        syUserLoginInfo.phone,
                        syUserLoginInfo.areaCode || '86'
                      )}
                    </span>
                  </p>
                </div>
              </div>
              <div className="btn-wrap">
                <button
                  className="daidai-btn-primary questions"
                  onClick={this.handleQuestions}
                >
                  身份验证遇到问题？
                </button>
                <button
                  className="daidai-btn-primary confirm"
                  onClick={this.handleConfirm}
                >
                  我同意，{this.isWeixinLogin() ? '微信' : 'QQ'}授权验证身份
                </button>
              </div>
            </div>
          ) : null}
        </Modal>

        <SecondaryAuthorization
          ref={(el) => (this.secondaryAuthorizationEle = el)}
          base={this.props.base}
        />

        {/* 通用弹窗 */}
        <IframeModal wrappedComponentRef={(el) => (this.iframeElement = el)} />
      </Fragment>
    );
  }
}
